import { useEffect, useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import SelectInput from '../../../../Core/Fields/SelectInput';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { useGetTaxcategoryQuery, useGetAllcompanyQuery } from '../../../../store/api/Salestaxes';

const Tab1 = ({ formdata, setformdata, handlechange }) => {

    const [taxoptions, setTaxoptions] = useState([])
    const [companyoptions, setCompanyoptions] = useState([])
    const { data: taxCat, isError, isLoading } = useGetTaxcategoryQuery()
    const { data: companydata } = useGetAllcompanyQuery()

    useEffect(() => {
        if (taxCat?.data?.length) {
            setTaxoptions(taxCat.data)
        }
    }, [taxCat])
    useEffect(() => {
        if (companydata?.data?.length) {
            setCompanyoptions(companydata.data)
        }
    }, [companydata])



    const [selectedCompany, setSelectedCompany] = useState('')

    return (
        <div
            className="row mb-3"
            style={{ border: "1px solid #00000059", borderRadius: "5px" }}
        >
            <div className="col-12">
                <p className="boxLabel m-0">Details</p>
            </div>
            <div className='d-flex mx-2'>
                <div className="d-flex" style={{ gap: '1rem', width: '100%' }}>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name='title'
                                readOnly
                                label="Title"
                                value={formdata.title}
                                onChange={handlechange}
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name='taxcategory'
                                label="Tax Category"
                                value={formdata.taxcategory}
                                readOnly
                                onChange={(e) =>
                                    setformdata((prev) => ({
                                        ...prev,
                                        taxcategory: e.target.value,
                                    }))
                                }
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: '1' }}>
                        <div className="mb-3">
                            <Input
                                name='company'
                                label="Company"
                                value={formdata.company}
                                readOnly
                                onChange={(e) =>
                                    setformdata((prev) => ({
                                        ...prev,
                                        company: e.target.value,
                                    }))
                                }
                                style={{ height: "30px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-2 mb-3 mx-3' style={{ display: 'flex', gap: '1rem', gap: '130px' }}>
                <div>
                    <input
                        type="checkbox"
                        name="default"
                        disabled
                        checked={formdata.default}
                        onChange={(e) =>
                            setformdata((prev) => ({
                                ...prev,
                                default: e.target.checked,
                            }))
                        }
                        style={{ width: "10px", height: "10px" }}
                    />
                    <label htmlFor="default" style={{ marginLeft: "0.5rem", fontSize: "0.8rem" }}>
                        Default
                    </label>
                </div>

                <div>
                    <input
                        type="checkbox"
                        name="disabled"
                        disabled
                        checked={formdata.disabled}
                        onChange={(e) =>
                            setformdata((prev) => ({
                                ...prev,
                                disabled: e.target.checked,
                            }))
                        }
                        style={{ width: "10px", height: "10px" }}
                    />
                    <label htmlFor="disabled" style={{ marginLeft: "0.5rem", fontSize: "0.8rem" }}>
                        Disabled
                    </label>
                </div>
            </div>
        </div>
    )
}

export default Tab1